/* eslint-disable no-param-reassign */
import cloneDeep from "lodash-es/cloneDeep";
import { propPanelMixin } from "../../../../../lib/helpers";
import PluginConfigPanel from "./PluginConfigPanel";
const __script_base__ = {
  name: 'PluginCardList',
  mixins: [propPanelMixin],
  components: {
    PluginConfigPanel
  },
  data() {
    return {
      plugins: []
    };
  },
  created() {
    this.getPlugins();
    this.$watch('plugins', () => this.$emit('update:plugins', this.plugins), {
      immediate: true
    });
  },
  computed: {
    // 注册的但是没有使用的组件
    unusedPlugins() {
      return Object.values(this.plugins).map(plugin => ({
        id: plugin.id,
        name: plugin.name,
        global: plugin.global
      })).filter(plugin => !this.usedPlugins.find(item => item.id === plugin.id));
    },
    // 已经被这个组件使用的组件
    usedPlugins() {
      // 在组件layout中登记使用的插件
      const pluginKeysFromLayout = Object.keys(this.comp.plugins || {});
      // 全局启用的插件
      const globalPluginKeys = Object.values(this.plugins).filter(plugin => plugin.global).map(plugin => plugin.id);
      // 聚集在一起去重，就是这个组件使用的插件
      const usedPluginKeys = new Set([...pluginKeysFromLayout, ...globalPluginKeys]);
      // 根据整理好的key, 生成使用的插件数组
      const usedPlugins = [];
      usedPluginKeys.forEach(key => {
        var _this$comp$plugins;
        let pluginInfo = {
          id: key,
          data: ((_this$comp$plugins = this.comp.plugins) === null || _this$comp$plugins === void 0 ? void 0 : _this$comp$plugins[key]) || ''
        };
        const info = this.plugins[key];
        if (!info) {
          console.error(`[ui-core plugin]使用了未注册的插件${key}, 请确保插件id的正确性`);
          pluginInfo.name = `未注册的插件${key}`;
        } else {
          pluginInfo = {
            ...pluginInfo,
            ...info
          };
        }
        usedPlugins.push(pluginInfo);
      });
      return usedPlugins;
    }
  },
  methods: {
    getPlugins() {
      const {
        componentPlugins
      } = this.uc;
      if (!componentPlugins) return;
      this.plugins = cloneDeep(componentPlugins);
    },
    handlePluginRemove(id) {
      this.removePlugin(id);
    },
    handlePluginSelected(id) {
      this.usePlugin(id);
    },
    handlePluginConfigChange(id, value) {
      this.modifyComp(c => {
        c.plugins[id] = value;
      });
    },
    usePlugin(id) {
      this.modifyComp(c => {
        if (!c.plugins) c.plugins = {};
        c.plugins[id] = '';
      });
    },
    removePlugin(id) {
      var _this$plugins$id;
      if ((_this$plugins$id = this.plugins[id]) !== null && _this$plugins$id !== void 0 && _this$plugins$id.global) {
        this.$message.error('全局启用的插件不可以被删除');
        return;
      }
      this.modifyComp(c => {
        delete c.plugins[id];
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [!Object.keys(_vm.plugins).length ? _c("div", {
    staticClass: "ucd-eventPanel-noEventPlaceholder"
  }, [_vm._v("\n    未注册任何插件\n  ")]) : _c("div", {
    staticClass: "ucd-eventPanel-eventCardList",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._l(_vm.usedPlugins, function (plugin) {
    return _c("PluginConfigPanel", {
      key: plugin.id,
      attrs: {
        plugin: plugin
      },
      on: {
        delete: function ($event) {
          return _vm.handlePluginRemove(plugin.id);
        },
        change: function ($event) {
          return _vm.handlePluginConfigChange(plugin.id, $event);
        }
      }
    });
  }), _vm._v(" "), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-around"
    }
  }, [_vm.unusedPlugins.length ? _c("select", {
    staticClass: "uc-inputbox",
    staticStyle: {
      flex: "1"
    },
    attrs: {
      width: "100%"
    },
    on: {
      change: function (e) {
        _vm.handlePluginSelected(e.target.value);
        e.target.selectedIndex = 0;
      }
    }
  }, [_c("option", {
    attrs: {
      value: "",
      selected: "",
      hidden: ""
    }
  }, [_vm._v("\n          添加插件\n        ")]), _vm._v(" "), _vm._l(_vm.unusedPlugins, function (plugin) {
    return _c("option", {
      key: plugin.id,
      domProps: {
        value: plugin.id
      }
    }, [_vm._v("\n          " + _vm._s(plugin.name) + "\n        ")]);
  })], 2) : _vm._e()])], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/PluginCardList/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);